import React, { useState } from 'react'

import { SocialAPI } from '@api/social';
import { Swiper } from '@element/index';
import { useIsomorphicLayoutEffect } from '@lib/hooks/useIsomorphicLayoutEffect'
import pubsub from '@lib/scripts/pubsub';

import { rendercont } from './rendercont/index';

import styles from './index.module.less'
const LIMIT = 6

const RecommendData = (props) => {
  const [recommendAllData, setRecommendAllData] = useState([]) // 获取的总数据

  const getTopicData = async () => {
    const params = {
      limit: LIMIT,
      language: 'zh'
    }
    const res = await SocialAPI.getTopicAll(params)
    if (res && res.result) {
      const topicAllData = res.result
      setRecommendAllData(topicAllData)
    }
  }

  useIsomorphicLayoutEffect(() => {
    getTopicData()
  }, [])
  useIsomorphicLayoutEffect(() => {
    pubsub.subscribe('UPDATE_SOCIAL_FEED', getTopicData);
    return () => {
      pubsub.unSubscribe('UPDATE_SOCIAL_FEED', getTopicData);
    };
  }, []);
  return (
    <div className={styles.recommendContent}>
      <Swiper
        dataSource={recommendAllData}
        pageSize={3}
        renderItem={rendercont}
        ItemSeparatorMargin='16px'
        containerClassName={styles.containerClassName}
        listClass={styles.list}
      />
    </div>
  )
};
export default RecommendData
